import { lazy } from "react";
import { routes } from "./index";
import Layout from "../layout";
import ProtectedRoute from "./protect-route";
import Loadable from "../common/components/loadable";
import ProvidersWrapper from "../context/app-provider";
import ViewTopics from "../pages/validateTopics/viewTopics";

const Dashboard = Loadable(lazy(() => import("../pages/dashboard")));
const User = Loadable(lazy(() => import("../pages/user")));
const Advisor = Loadable(lazy(() => import("../pages/advisors")));
const Topics = Loadable(lazy(() => import("../pages/topics")));
const ValidateTopics = Loadable(lazy(() => import("../pages/validateTopics")));
const GlobalSettings = Loadable(lazy(() => import("../pages/globalsettings")));
const Report = Loadable(lazy(() => import("../pages/reoprt")));
const Transaction = Loadable(lazy(() => import("../pages/transactions")));


// Define which roles are allowed to access each route
const protectedRoutes = [
  { path: routes.DASHBOARD, element: <Dashboard /> },
  { path: routes.USERS, element: <User /> },
  { path: routes.ADVISORS, element: <Advisor /> },
  { path: routes.TOPICS, element: <Topics /> },
  { path: routes.VALIDATETOPICS, element: <ValidateTopics /> },
  { path: routes.SETTINGS, element: <GlobalSettings /> },
  { path: routes.VIEWTOPICS, element: <ViewTopics /> },
  { path: routes.REPORT_ISSUE, element: <Report /> },
  { path: routes.TRANSACTIONS, element: <Transaction /> },
];

const mainRoutes = {
  element: (
    <ProvidersWrapper>
      <Layout />
    </ProvidersWrapper>
  ),
  children: protectedRoutes.map(({ path, element }) => ({
    path,
    element: <ProtectedRoute>{element}</ProtectedRoute>,
  })),
};

export default mainRoutes;